const SiteColorItem = ({ color = "", type = "color", value = "", onChange, name }) => {
  return (
    <div className="py-0 relative">
      <div className="text-black font-semibold text-xs mb-1 leading-none uppercase">{name}</div>
      <div className="flex items-center pr-4">
        {type === "color" && (
          <div className="w-8 h-6">
            <input
              className="uppercase"
              id={`color-picker-${name}`}
              type="color"
              value={color}
              onChange={(e) => onChange("#" + e.target.value.split("#")[1]?.toUpperCase())}
            />
          </div>
        )}
        {type === "color" ? (
          <>
            #
            <input
              value={color.split("#")[1]?.toUpperCase()}
              className="border-none rounded-md bg-transparent w-full focus:border-none overflow-x-hidden"
              onChange={(e) => onChange("#" + e.target.value?.toUpperCase())}
            />
          </>
        ) : (
          <div className="flex items-center space-x-1">
            <input
              value={value}
              className="!border border-slate-200 rounded-md bg-transparent w-28 focus:border-none overflow-x-hidden text-sm px-1 py-1"
              onChange={(e) => onChange(e.target.value)}
            />
            <div className="text-[8px] text-black leading-tight">Use percentage or pixel (i.e. "%" or "px")</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SiteColorItem;
